enum TomorrowPlanType {
  LegalAge = 1,
  UnderAge = 2
}

export default TomorrowPlanType;
